import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

const rawSupabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
// Valeur relative (`/sb`, proxy same-origin Cloudflare Pages Function) : supabase-js
// exige une URL absolue, on la résout contre l'origin de la page.
const supabaseUrl = rawSupabaseUrl?.startsWith('/') ? new URL(rawSupabaseUrl, window.location.origin).toString() : rawSupabaseUrl
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY env vars')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// Note: pour invoquer une edge function, utiliser `invokeEdge` de ./invokeEdge.ts
// (fetch direct avec apikey + Bearer JWT user explicites). Le wrapper legacy
// `invokeFn` qui passait par supabase.functions.invoke a ete supprime le 19/04
// car le SDK envoyait parfois l'anon_key au lieu du JWT user -> 401 gateway.
